import Viewer from "./Viewer"
import Editor from "./Editor"

export default {
    name: "activityMultipleChoice",
    title: "Activity Multiple Choice",
    icon: require("./content-icon.svg"),
    category: "training",
    Viewer,
    Editor,
    Preview: Viewer
}